// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedTemplatesRouteImport } from './routes/_authenticated/templates'
import { Route as AuthenticatedSegmentsRouteImport } from './routes/_authenticated/segments'
import { Route as AuthenticatedOrganizationsRouteImport } from './routes/_authenticated/organizations'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedContactsRouteImport } from './routes/_authenticated/contacts'
import { Route as AuthenticatedCampaignsRouteImport } from './routes/_authenticated/campaigns'
import { Route as AuthenticatedAuditRouteImport } from './routes/_authenticated/audit'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'

const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedTemplatesRoute = AuthenticatedTemplatesRouteImport.update({
            id: '/templates',path: '/templates',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSegmentsRoute = AuthenticatedSegmentsRouteImport.update({
            id: '/segments',path: '/segments',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOrganizationsRoute = AuthenticatedOrganizationsRouteImport.update({
            id: '/organizations',path: '/organizations',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedContactsRoute = AuthenticatedContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCampaignsRoute = AuthenticatedCampaignsRouteImport.update({
            id: '/campaigns',path: '/campaigns',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAuditRoute = AuthenticatedAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedAuditRoute: AuthenticatedAuditRoute,AuthenticatedCampaignsRoute: AuthenticatedCampaignsRoute,AuthenticatedContactsRoute: AuthenticatedContactsRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedOrganizationsRoute: AuthenticatedOrganizationsRoute,AuthenticatedSegmentsRoute: AuthenticatedSegmentsRoute,AuthenticatedTemplatesRoute: AuthenticatedTemplatesRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)